// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  font-family: "Cairo", sans-serif;
}

.collapsible-title {
  font-size: 16px;
  font-weight: 600;
}

.collapsible-content {
  font-size: 14px;
}

.card-header-actions {
  margin-inline-start: auto;
  margin-inline-end: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/collapsed-card/collapsed-card.component.scss"],"names":[],"mappings":"AAAA;EACI,gCAAA;AACJ;;AAEE;EACE,eAAA;EACA,gBAAA;AACJ;;AAEE;EACE,eAAA;AACJ;;AAEA;EACE,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AACF","sourcesContent":[":host {\n    font-family: 'Cairo', sans-serif;\n  }\n  \n  .collapsible-title {\n    font-size: 16px;\n    font-weight: 600;\n  }\n  \n  .collapsible-content {\n    font-size: 14px;\n  }\n\n.card-header-actions {\n  margin-inline-start: auto;\n  margin-inline-end: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
